@let insideDropdown = $insideDropdown();

@if (insideDropdown) {
  <div class="p-[20px]">
    <x-request-form-statuses-list
      [formControl]="formControl"
      [readOnly]="(canLogistChangeRequestStatus$ | async) === false"
      [errorHappened]="errorHappened$"
      [insideDropdown]="true"
      (statusChangeInProcess)="$statusChangeInProcess.emit($event)"
    ></x-request-form-statuses-list>
  </div>
} @else {
  <div class="w-full px-2 pb-2">
    <div
      class="x-card x-card_size_s m-auto x-white card-shadow border mt-4.5 md:w-1/3"
    >
      <x-request-form-statuses-list
        [formControl]="formControl"
        [readOnly]="(canLogistChangeRequestStatus$ | async) === false"
        [errorHappened]="errorHappened$"
        [insideDropdown]="false"
      ></x-request-form-statuses-list>
    </div>
  </div>
}
